import CachedIcon from "mdi-react/CachedIcon";
import React, { useEffect, useState } from "react";
import { Form, Button, InputGroup, Dropdown } from "react-bootstrap";
import TableComponent from "../TableComponent";
import {
  Checked,
  CustomerAccountSelectIcon,
  DownloadIcon,
  FilterCollapseIcon,
  FilterTwoIcon,
  LoaderIcon,
  ViewIcon,
  EmailIcon,
  FormAllIcon,
  ChartPieSliceIcon,
} from "../Icons";
import useDebounce, {
  useLocalStorage,
  useQueryParams,
} from "../../utils/hooks";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { format } from "date-fns";
import queryString from "query-string";
import { formatDate, paginationOptions, slugify } from "../../utils/helpers";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import ReactPaginate from "react-paginate";
import NoTableItem from "../utils/NoTableItem";
import Select from "react-select";
import { isEmpty, truncate } from "lodash";
import { useNavigate, useOutletContext } from "react-router-dom";
import PartnerDetails from "./PartnerDetails";
import PrincingModal from "./PrincingModal";
import DocumentUpload from "./DocumentUpload";
import ConfirmDialog from "../ConfirmDialogue";
import { toast } from "react-toastify";
import ContactPartnerModal from "./ContactPartnerModal";
import FormSelectorModal from "../CustomersEmail/FormSelectorModal";
import { HoverDropDown } from "../Component";
import { useCreateFormLink } from "../../hooks/mutations/useCreateFormLink";
import { v4 as uuidv4 } from "uuid";
import FilledSharedForms from "../Requisition/FilledSharedForms";
import ModalLoader from "../utils/ModalLoader";
import SendDocumentsModal from "./modals/SendDocumentsModal";

const partnerStatuses = [
  { label: "Verified", value: "verified" },
  { label: "Unverified", value: "unverified" },
];

export default function EBCompanyList() {
  const navMetaData = useOutletContext();
  const createFormLinkMutation = useCreateFormLink();

  const { backendUrl, token, user: authUser } = useAuth();
  const [showFilter, setShowFilter] = useLocalStorage(
    "showEBCompanyFilter",
    true,
  );

  const [showCompanyBranchModal, setShowCompanyModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [multiSelectionMode, setMultiSelectionMode] = useState(false);
  const [selectedPartnerDetails, setSelectedPartnerDetails] = useState(null);
  const [showDocumentUploadModal, setShowDocumentUploadModal] = useState(false);
  const [partnerList, setPartnerList] = useState([]);
  const [showContactPartnerModal, setShowContactPartnerModal] = useState(false);
  const { user } = useAuth();
  const initialFilterParams = {
    companyName: "",
    startDate: "",
    endDate: "",
    companyID: "",
  };
  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });
  const [multiSelected, setMultiSelected] = useState([]);
  // const [selectedStatus, setSelectedStatus] = useState('verified')

  const [showFormSelectorModal, setShowFormSelectorModal] = useState(false);
  const [showFilledFormsModal, setShowFilledFormsModal] = useState(false);
  const [showSendDocumentsModal, setShowSendDocumentsModal] = useState(false);

  const fetchInvexPartners = async (query) => {
    const res = await fetch(
      `${backendUrl}/api/partnership/invexerp-partners?${queryString.stringify(
        query,
      )}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      },
    );
    if (!res.ok) {
      toast.error("unable to get partners");
      return [];
    }
    const data = await res.json();

    return data;
  };

  const updateInvexPartner = async (payload) => {
    try {
      console.log(payload);
      const res = await fetch(
        `${backendUrl}/api/partnership/invexerp-partner`,
        {
          method: "PUT",
          credentials: "include",
          body: JSON.stringify(payload),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        },
      );

      if (!res.ok) throw new Error(`Error: ${res.status} ${res.statusText}`);

      return await res.json(); // Parse response as JSON
    } catch (error) {
      console.error("Update failed:", error);
      throw error;
    }
  };

  const { data, refetch, isFetching, isSuccess } = useQuery(
    ["GET_INVEX_PARTNERS", queryParams],
    () => fetchInvexPartners(queryParams),

    {
      enabled: true,
      keepPreviousData: true,
    },
  );

  useEffect(() => {
    setPartnerList(data?.data || []);

    if (data && data.metaData) {
      let verified = data?.metaData.verified;
      navMetaData({
        stat1: {
          value: data?.metaData.total,
          label: "Total partners",
        },
        stat2: {
          value: verified,
          label: "Total verified",
        },
        stat3: {
          value: data?.metaData.total - verified,
          label: "Total unverified",
        },
      });
    }
  }, [data]);

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      ...debouncedFilterParams,
    });
  }, [debouncedFilterParams, setQueryParams]);

  const handleFilterParamsChange = (e) => {
    let searchValue = e.target.value?.toLowerCase();
    setPartnerList(() =>
      data.filter(
        ({
          company_name,
          company_email,
          first_name,
          last_name,
          personal_email,
        }) => {
          return (
            company_name.toLowerCase().includes(searchValue) ||
            company_email.toLowerCase().includes(searchValue) ||
            first_name.toLowerCase().includes(searchValue) ||
            last_name.toLowerCase().includes(searchValue) ||
            personal_email.toLowerCase().includes(searchValue)
          );
        },
      ),
    );
  };
  const handleLocationChange = (e) => {
    let searchValue = e.target.value?.toLowerCase();
    setPartnerList(() =>
      data.filter(({ country, state, city }) => {
        return (
          country.toLowerCase().includes(searchValue) ||
          state.toLowerCase().includes(searchValue) ||
          city.toLowerCase().includes(searchValue)
        );
      }),
    );
  };

  const filterByDateRange = (date) => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      enableDateRange: true,
    });
  };

  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };
  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
  };

  const handleSearchQueryChange = (e) => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const allSelected = multiSelected?.length === data?.data?.length;
  const handleCheckboxChange = (id) => {
    setMultiSelected(
      (prevSelected) =>
        prevSelected.includes(id)
          ? prevSelected.filter((item) => item !== id) // Remove if already selected
          : [...prevSelected, id], // Add if not selected
    );
  };

  const handleVerify = async (partner) => {
    try {
      if (
        await ConfirmDialog({
          description: `Are you sure you want to ${
            partner?.is_verified ? "unverify" : "verify"
          } ${
            partner
              ? "this partner"
              : "all (" + multiSelected.length + ") partners"
          }`,
        })
      ) {
        setIsLoading(true);
        if (partner !== undefined) {
          let payload = {
            id: [partner.id],
            action: { is_verified: !Boolean(partner.is_verified) },
          };
          await updateInvexPartner(payload);
        } else {
          let payload = { id: multiSelected };
          await updateInvexPartner(payload);
        }
      }
    } catch (error) {
      console.error("Error verifying:", error);
    } finally {
      await refetch();
      setMultiSelectionMode(false);
      setIsLoading(false);
    }
  };

  const fetchPartnerDashboardLink = async (partner) => {
    try {
      setIsLoading(true);
      const res = await fetch(
        `${backendUrl}/api/partnership/admin-auth-link/${user.Staff_ID}/${
          partner.id
        }`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        },
      );
      if (!res.ok) throw new Error(`Error: ${res.message}`);
      const data = await res.json();
      if (data.token) {
        // redirect to the dashboard link
        window.open(
          `http://partners.invexerp.com/api/admin/auth?token=${data.token}`,
          "_blank",
        );
      } else {
        // show error message
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error fetching dashboard link:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          {multiSelectionMode && (
            <th>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={(e) => {
                  setMultiSelected(
                    allSelected ? [] : data?.data.map((item) => item.id),
                  );
                }}
              />
            </th>
          )}
          <th>
            <Button
              variant="white"
              size="sm"
              onClick={() => {
                setMultiSelected(data?.data.map((item) => item.id));
                setMultiSelectionMode((prev) => !prev);
              }}
            >
              {" "}
              {/* <SettingsIcon color="white" /> */}
              {multiSelectionMode ? "Cancel" : "Select all"}
            </Button>
          </th>
          {/* <th>Company ID</th> */}

          <th>Company name</th>
          <th>Company email</th>
          <th>Personal email</th>

          <th>Country</th>
          <th>State</th>
          <th>City</th>

          <th>First Name</th>
          <th>Last Name</th>

          <th>Date Registered</th>
          <th>Approved</th>
        </tr>
      </thead>
    );
  };

  const getStatus = (date) => {
    const currentDate = new Date().getTime();
    let expiringDate = new Date(date);
    expiringDate.setDate(expiringDate.getDate() - 0);

    expiringDate = new Date(expiringDate).getTime();

    let timeDiff = currentDate - expiringDate;

    let daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));

    let status;

    if (daysDiff > 9) {
      status = "Suspended";
    } else {
      status = currentDate > expiringDate ? "Expired" : "Active";
    }

    return status;
  };

  function getExpiringDate(date) {
    let expDate = new Date(date);

    expDate.setDate(expDate.getDate() - 0);

    return expDate;
  }

  const tableData = (el, index) => {
    return (
      <>
        {multiSelectionMode && (
          <td>
            <input
              type="checkbox"
              checked={multiSelected.includes(el.id)}
              onChange={() => {
                handleCheckboxChange(el.id);
              }}
            />
          </td>
        )}

        <td>
          <Dropdown alignRight drop="end">
            <Dropdown.Toggle
              variant=""
              className="bg-white border-0"
              bsPrefix="print more"
            >
              <DotsVerticalIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu
              popperConfig={{
                strategy: "fixed",
              }}
              renderOnMount
              className="dropdown-with-icons"
            >
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setSelectedPartnerDetails(el);
                  setShowCompanyModal(true);
                }}
              >
                <ViewIcon /> View partner
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  handleVerify(el);

                  // setShowEmailAddressModal(true);
                }}
              >
                <Checked color="#94A3B8" />
                {el.is_verified ? "Unverify partner" : "Verify partner"}
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setSelectedPartnerDetails(el);
                  setShowDocumentUploadModal(true);
                }}
              >
                <DownloadIcon />
                Upload docs{" "}
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setSelectedPartnerDetails(el);
                  setShowContactPartnerModal(true);
                }}
              >
                <EmailIcon />
                Contact partner
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  fetchPartnerDashboardLink(el);
                }}
              >
                <CustomerAccountSelectIcon />
                Goto dashboard
              </Dropdown.Item>

              <Dropdown.Divider />

              <HoverDropDown alignRight drop="end" className="w-100">
                <Dropdown.Toggle
                  variant=""
                  className="w-100 dropdown-item justify-content-between"
                >
                  <span className="d-flex gap-2">
                    <ChartPieSliceIcon /> Partner Recruitment & Qualification
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      setSelectedPartnerDetails(el);
                      setShowFormSelectorModal(true);
                    }}
                    as="button"
                  >
                    Send Forms
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setSelectedPartnerDetails(el);
                      setShowFilledFormsModal(true);
                    }}
                    as="button"
                  >
                    Shared / Filled Forms
                  </Dropdown.Item>

                  <Dropdown.Divider />
                  <Dropdown.Item
                    onClick={() => {
                      setSelectedPartnerDetails(el);
                      setShowSendDocumentsModal(true);
                    }}
                    as="button"
                  >
                    Send Documents
                  </Dropdown.Item>
                </Dropdown.Menu>
              </HoverDropDown>
            </Dropdown.Menu>{" "}
          </Dropdown>
        </td>

        {/* <td>{el?.companyID}</td> */}
        <td>{el?.company_name}</td>
        <td style={{ wordBreak: "break-all" }}>{el?.company_email}</td>
        <td style={{ wordBreak: "break-all" }}>{el?.personal_email}</td>
        <td>{el?.country}</td>
        <td>{el?.state}</td>
        <td>{el?.city}</td>
        <td>{el?.first_name}</td>
        <td>{el?.last_name}</td>

        <td>
          {el?.createdAt ? (
            <>
              <div>{`${formatDate(
                new Date(el?.createdAt),
                "dd MMM, yyyy",
              )}`}</div>
              <div
                className=""
                style={{ fontSize: "12px", fontStyle: "italic" }}
              >
                {`${formatDate(new Date(el?.createdAt), "hh:mm a")}`}
              </div>
              <div>
                {truncate(el?.lastSeenBranch, {
                  length: 15,
                })}
              </div>
            </>
          ) : (
            "..."
          )}
        </td>
        {/*
        <td>
          {!isNaN(new Date(el?.companyDateCreated).getTime())
            ? format(new Date(el?.companyDateCreated), "dd MMM, yyyy")
            : "..........."}
        </td>
        <td>
          {!isNaN(new Date(el?.companyExpiringDate).getTime())
            ? format(new Date(el?.companyExpiringDate), "dd MMM, yyyy")
            : "............"}
        </td> */}
        <td
          className={`
             "expiring-date-color  fw-bold"
            ${el?.is_verified ? "text-success fw-bold" : "text-danger fw-bold"}
          `}
          style={{ textTransform: "capitalize" }}
        >
          {String(Boolean(el?.is_verified))}
        </td>
      </>
    );
  };

  const handleSelectedForms = (selectedForms) => {
    // console.log(selectedForms);
    // console.log(selectedPartnerDetails);

    if (!selectedPartnerDetails.company_email) {
      return toast.error("No Company email found");
    }

    // We need to send the forms to the partners
    createFormLinkMutation.mutate(
      selectedForms.map((form) => {
        const shareToken = uuidv4();
        return {
          entityType: "Form",
          entityId: form.id,
          accessType: "public", // "private" or "password"
          expiresAt: null, // optional
          receiverEmail: selectedPartnerDetails.company_email,
          entityLink: `${window.location.origin}/shared-form/${form.id}/${
            authUser.company
          }/${slugify(form.Title)}/${shareToken}`,
          token: shareToken,
          partnerId: selectedPartnerDetails.id,
          form,
          usage: "Partner Recruitment & Qualification",
        };
      }),
      {
        onSuccess: (data) => {
          const token =
            Array.isArray(data.data) && data.data.length > 0
              ? data.data[0].token
              : data.data.token;

          console.log(`Share link created: ${backendUrl}/share/${token}`);
        },
        onError: (err) => {
          toast.error(`Error: ${err.message}`);
        },
      },
    );
  };

  return (
    <>
      {showCompanyBranchModal && (
        <PartnerDetails
          data={selectedPartnerDetails}
          setShow={setShowCompanyModal}
        />
      )}

      {showDocumentUploadModal && (
        <DocumentUpload
          refetch={refetch}
          setShow={setShowDocumentUploadModal}
          partner={selectedPartnerDetails}
        />
      )}

      <main className="cash-book ">
        <div className="content ">
          <div className="content-main pt-0">
            <div className={`filter-area ${showFilter ? "open" : "close"}`}>
              <div className="filter-header">
                <h2>
                  <FilterTwoIcon /> Filters
                </h2>

                <Button
                  variant="white"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <FilterCollapseIcon />
                </Button>
              </div>
              <div className="filter-body">
                <Form>
                  <div className="body" style={{ height: "40em" }}>
                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Campany Name</Form.Label>{" "}
                      <InputGroup>
                        <Form.Control
                          name="companyName"
                          // value={filterParams?.companyName}
                          placeholder="Enter company name"
                          onChange={(e) => handleFilterParamsChange(e)}
                        />{" "}
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Location</Form.Label>{" "}
                      <InputGroup>
                        <Form.Control
                          name="location"
                          // value={filterParams.companyID}
                          placeholder="Enter country, state or city"
                          onChange={(e) => handleLocationChange(e)}
                        />{" "}
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Filter status</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        placeholder="Filter by status"
                        isSearchable={false}
                        isClearable
                        options={partnerStatuses}
                        value={partnerStatuses.find(
                          (el) => el === filterParams.is_verified,
                        )}
                        onChange={(selected) => {
                          console.log(selected);
                          setQueryParams({
                            ...filterParams,
                            page: 1,
                            is_verified: selected?.value,
                          });
                        }}
                      />
                    </Form.Group>

                    <hr className="mt-3 mb-4" />
                  </div>
                </Form>
              </div>
            </div>
            <div className="content-body">
              <header>
                <h1>
                  {!showFilter && (
                    <button
                      onClick={() => setShowFilter(!showFilter)}
                      className="btn filter"
                    >
                      <FilterTwoIcon />
                    </button>
                  )}
                  Partner List
                  <button
                    title="Refresh"
                    className="btn text-primary"
                    onClick={() => {
                      refetch();
                    }}
                  >
                    <CachedIcon />
                  </button>
                </h1>
                <div className="actions">
                  {multiSelectionMode && (
                    <Button
                      disabled={!Boolean(multiSelected?.length)}
                      variant="primary"
                      onClick={() => {
                        multiSelected?.length && handleVerify();
                      }}
                    >
                      Approve selected
                    </Button>
                  )}
                </div>
              </header>

              <div className="mx-3">
                <TableComponent
                  responsive
                  borderless
                  striped
                  tableHeadsFunction={tableHead}
                  mainDataArray={partnerList || []}
                  className="product-table text-nowrap"
                  tableDataRowFunction={tableData}
                  // tableRowClick={(e, el) => manageTransaction(e, el)}
                />

                {!isFetching && isSuccess && isEmpty(data) ? (
                  <NoTableItem queryParams={queryParams} />
                ) : null}
              </div>

              <div className="d-flex justify-content-between px-3 align-items-center pagination">
                <div className="pagination_left">
                  <p className="m-0 p-0">Show</p>
                  <select
                    value={queryParams.limit}
                    name="limit"
                    className="form-select "
                    onChange={(e) => handleSearchQueryChange(e)}
                  >
                    <option value="10">10 rows</option>
                    <option value="20">20 rows</option>
                    <option value="30">30 rows</option>
                    <option value="40">40 rows</option>
                    <option value="50">50 rows</option>
                    <option value="100">100 rows</option>{" "}
                  </select>
                </div>

                <ReactPaginate
                  {...paginationOptions}
                  pageCount={Math.ceil(
                    data?.pagination?.total / queryParams.limit,
                  )}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={0}
                  onPageChange={({ selected }) => {
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    setQueryParams({
                      ...queryParams,
                      page: selected + 1,
                    });
                  }}
                  forcePage={queryParams.page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      </main>

      {selectedPartnerDetails && showContactPartnerModal ? (
        <ContactPartnerModal
          partner={selectedPartnerDetails}
          setShow={setShowContactPartnerModal}
          backendUrl={backendUrl}
          token={token}
        />
      ) : null}

      {showFormSelectorModal && (
        <FormSelectorModal
          showchildForm={showFormSelectorModal}
          setShowChildForm={setShowFormSelectorModal}
          handleSelectedForms={handleSelectedForms}
        />
      )}

      {selectedPartnerDetails && showFilledFormsModal ? (
        <FilledSharedForms
          partner={selectedPartnerDetails}
          setShowFilledFormsModal={setShowFilledFormsModal}
        />
      ) : null}

      {/* G.A. */}
      {selectedPartnerDetails && showSendDocumentsModal ? (
        <SendDocumentsModal
          show={showSendDocumentsModal}
          setShow={setShowSendDocumentsModal}
          partner={selectedPartnerDetails}
        />
      ) : null}

      {isLoading && (
        <div className="global-spinner">
          <LoaderIcon className="spin text-primary" />
        </div>
      )}

      <ModalLoader show={createFormLinkMutation.isLoading} />
    </>
  );
}
